// V2 Production Configuration
// Uses env var if set, falls back to workflow86.com for backward compatibility
const STAGE = process.env.REACT_APP_STAGE || 'production';
const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN || 'workflow86.com';
const API_BASE = process.env.REACT_APP_API_ADDRESS || `https://api.${ROOT_DOMAIN}`;

// Log warning if using fallback (helps identify missing config in logs)
if (typeof window !== 'undefined' && !process.env.REACT_APP_ROOT_DOMAIN) {
  console.warn('[config] REACT_APP_ROOT_DOMAIN not set, using default: workflow86.com');
}

// V2 production uses workflow86.com
const isV2 = ROOT_DOMAIN === 'workflow86.com' || STAGE === 'v2-production';

// For local development, use V2 production API (has localhost CORS)
// Use 'docker' stage for actual local backend development
const useLocalBackend = STAGE === 'docker';

const config = {
  VERSION: '0.0.1',
  API_ADDRESS:
    useLocalBackend
      ? 'http://localhost:3000/forms'
      : STAGE === 'dev'
        ? 'https://formservice.w86dev.click:5000/forms'
        : isV2
          ? `${API_BASE}/forms`
          : 'https://formservice.workflow86.com/forms',
  USER_ADDRESS:
    useLocalBackend
      ? 'http://localhost:9100/authz-service'
      : STAGE === 'dev'
        ? 'https://p4yrku69a0.execute-api.ap-southeast-2.amazonaws.com/dev/authz-service'
        : isV2
          ? `${API_BASE}/authz-service`
          : 'https://services.workflow86.com/authz-service',
  REGION: process.env.REACT_APP_AWS_REGION || 'ap-southeast-2',
  USER_POOL_ID:
    STAGE === 'dev'
      ? 'ap-southeast-2_Kp9DpRrdK'
      : process.env.REACT_APP_USER_POOL_ID || 'ap-southeast-2_4pkuaVYZY',
  APP_CLIENT_ID:
    STAGE === 'dev'
      ? '5f93lfrqqh7nruhjiiin8qbeem'
      : process.env.REACT_APP_APP_CLIENT_ID || '7k5h7tnrnkdcg78d9ofpt1opij',
  DOMAIN:
    STAGE === 'dev' ? '.w86dev.click' : `.${ROOT_DOMAIN}`,
  ISS:
    process.env.REACT_APP_COGNITO_ISS ||
    'https://cognito-idp.ap-southeast-2.amazonaws.com/ap-southeast-2_4pkuaVYZY',
  FILE_ADDRESS:
    useLocalBackend
      ? 'http://localhost:9200/file/get'
      : STAGE === 'dev'
        ? 'https://file.w86dev.click:9300/file/get'
        : isV2
          ? `${API_BASE}/ai-service/file/get`
          : 'https://file.workflow86.com/file/get',
  PROJECT_SERVICE_URL:
    useLocalBackend
      ? 'http://localhost:9000/project-service/project'
      : STAGE === 'dev'
        ? 'https://p4yrku69a0.execute-api.ap-southeast-2.amazonaws.com/dev/project-service/project'
        : isV2
          ? `${API_BASE}/project-service/project`
          : 'https://services.workflow86.com/project-service/project',
  ADMIN_DASHBOARD_URL:
    STAGE === 'dev'
      ? 'https://app.w86dev.click'
      : `https://app.${ROOT_DOMAIN}`,
  AUTOSAVE_INTERVAL: 30,
  ADOBE_CONFIG_API_KEY:
    STAGE === 'dev'
      ? '88d8993b747244238c1b0f87c182882c'
      : '59c87491d5964def8e84cf3dbcff2d16',
  UPLOAD_MEDIA_SIZE: 30000000,
  STAGE: STAGE,
  ROOT_DOMAIN: ROOT_DOMAIN,
};

export default config;
